// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes bake-pie {
  from {
    transform: rotate(0deg) translate3d(0,0,0);
  }
}
.graphChart .totalContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: clamp(0.8rem, 2vw, 1rem);
    font-weight: bold;
}
.graphChart main {
  width: clamp(300px, 30vw, 500px);
  /* margin: 30px auto; */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 20px;
}

.graphChart section {
  margin-top: 30px;
}

.graphChart .pieID {
  display: inline-block;
  vertical-align: top;
}

.graphChart .pie {
  height: 200px;
  width: 200px;
  position: relative;
  margin: 0 30px 30px 0;
}

.graphChart .pie::before {
  content: "";
  display: block;
  position: absolute;
  z-index: 1;
  width: 100px;
  height: 100px;
  background: #EEE;
  border-radius: 50%;
  top: 50px;
  left: 50px;
}
.graphChart .pie::after {
  content: "";
  display: block;
  width: 120px;
  height: 2px;
  background: rgba(0,0,0,0.1);
  border-radius: 50%;
  box-shadow: 0 0 3px 4px rgba(0,0,0,0.1);
  margin: 220px auto;
  
}
.graphChart .slice {
  position: absolute;
  width: 200px;
  height: 200px;
  clip: rect(0px, 200px, 200px, 100px);
  animation: bake-pie 1s;
}
.graphChart .slice span {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background-color: black;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  clip: rect(0px, 200px, 200px, 100px);
}
.graphChart .legend {
  list-style-type: none;
  padding: 0;
  margin: 0;
  /* background: #FFF; */
  padding: 15px;
  /* font-size: 13px;
  box-shadow: 1px 1px 0 #DDD,
              2px 2px 0 #BBB; */
}
.graphChart .legend li {
  /* width: 110px; */
  height: 1.25em;
  margin-bottom: 0.7em;
  padding-left: 0.5em;
  border-left: 1.25em solid black;
}
.graphChart .legend em {
  font-style: normal;
}
.graphChart .legend span {
  float: right;
}

`, "",{"version":3,"sources":["webpack://./src/assets/styles/dashboardItems.css"],"names":[],"mappings":"AAAA;EACE;IACE,0CAA0C;EAC5C;AACF;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mCAAmC;IACnC,iBAAiB;AACrB;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;;AAEpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,oCAAoC;EACpC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb;;+BAE6B;AAC/B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;AACjC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd","sourcesContent":["@keyframes bake-pie {\n  from {\n    transform: rotate(0deg) translate3d(0,0,0);\n  }\n}\n.graphChart .totalContainer{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-size: clamp(0.8rem, 2vw, 1rem);\n    font-weight: bold;\n}\n.graphChart main {\n  width: clamp(300px, 30vw, 500px);\n  /* margin: 30px auto; */\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border-radius: 12px;\n  padding: 20px;\n}\n\n.graphChart section {\n  margin-top: 30px;\n}\n\n.graphChart .pieID {\n  display: inline-block;\n  vertical-align: top;\n}\n\n.graphChart .pie {\n  height: 200px;\n  width: 200px;\n  position: relative;\n  margin: 0 30px 30px 0;\n}\n\n.graphChart .pie::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  z-index: 1;\n  width: 100px;\n  height: 100px;\n  background: #EEE;\n  border-radius: 50%;\n  top: 50px;\n  left: 50px;\n}\n.graphChart .pie::after {\n  content: \"\";\n  display: block;\n  width: 120px;\n  height: 2px;\n  background: rgba(0,0,0,0.1);\n  border-radius: 50%;\n  box-shadow: 0 0 3px 4px rgba(0,0,0,0.1);\n  margin: 220px auto;\n  \n}\n.graphChart .slice {\n  position: absolute;\n  width: 200px;\n  height: 200px;\n  clip: rect(0px, 200px, 200px, 100px);\n  animation: bake-pie 1s;\n}\n.graphChart .slice span {\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: black;\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  clip: rect(0px, 200px, 200px, 100px);\n}\n.graphChart .legend {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  /* background: #FFF; */\n  padding: 15px;\n  /* font-size: 13px;\n  box-shadow: 1px 1px 0 #DDD,\n              2px 2px 0 #BBB; */\n}\n.graphChart .legend li {\n  /* width: 110px; */\n  height: 1.25em;\n  margin-bottom: 0.7em;\n  padding-left: 0.5em;\n  border-left: 1.25em solid black;\n}\n.graphChart .legend em {\n  font-style: normal;\n}\n.graphChart .legend span {\n  float: right;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
